import React, {createRef} from 'react';
import { ThemeProvider} from 'emotion-theming';
import $ from "jquery";
import {themeBuilder} from '@cybs-plugins/theme';
import componentList from '../../data';
import {getLHSBasedOnHostName, navigateToSections, getLHSJsonData, getDefaultApiFromParentClass, getDefaultApiFromSubProductFamily, validateThirdLevelApiName, clearResponseFields} from '../actions/navigation-actions';
import {LoadJsonData} from '../../rhs/dynamic/actions/rhs-schema-actions';
import {initiateDeepLink } from '../actions/navigation-actions';
import './../css/lhs.css'
import showDivBasedOnId, {createClass, hideDivBasedOnId, isDefaultSite} from '../../commons/ui-commons';
import {replaceSpace, replaceUnderscoreWithSpace, setWindowLocationHash, titleCase, getProductMapJson} from '../../libs/common-library';
import {getProcessorMap } from '../reducers/configuration-reducer';
import { getFirstLevelKey, getPrerequisitesFlag, getSecondLevelKey, getSelectedApi} from '../reducers/lhs-reducer';
import {getSelectedSampleCode } from '../../rhs/dynamic/reducers/examples-reducer';
import {getDevCenterDataStore, putDataInDevCenterDataStore} from '../../app/store';
import {useSelector } from 'react-redux';
import { getPartnerName } from '../reducers/configuration-reducer';
import VDSUINavigation from "./vdsUINavigation";

var processed = false;
var lhsContents = {};
var superLhsContents = {};
var renderCounter = 0;

function navigationHelper(lhsContents, id){
    if(getSelectedApi() != id){
        if(!id.endsWith("_mainProduct")){
            putDataInDevCenterDataStore({type: 'UPDATE_SELECTED_API', selectedApi: id});

            $('a[state^="selected"]').removeAttr('state');
            $('a[href^='+id+']').attr('state','selected');

            navigateToSections(true,lhsContents,id);
            clearResponseFields();
            LoadJsonData();
            var currentHash = encodeURI(window.location.hash);
            var currentDecodedHash = decodeURI(currentHash);
            if(getSelectedSampleCode() != 'Live Console'){
                document.getElementById('button-live-console') && document.getElementById('button-live-console').click();
                setWindowLocationHash(currentDecodedHash);
            }
        }
    }
    else{
        var hashValue = encodeURI(window.location.hash);
        var decodedHashValue = decodeURI(hashValue);
        var urlArray = decodedHashValue.replace('#','').split('_');
        if (urlArray.length == 1){
            if (id === 'static-api-endpoints-section' || id === 'static-home-section'){
                setWindowLocationHash(decodedHashValue);
            } else {
                var newHashValue = getFirstLevelKey().toLowerCase().replaceAll('_','-')+'_'+getSecondLevelKey().toLowerCase().replaceAll(' ','-')+'_'+id;
                setWindowLocationHash(newHashValue);
            }

        }
    }
}

const selectCounterValue = state => state.firstLevelKey;
const CustomSliderExample = (props) => {
    const ref = createRef();
    var selected = useSelector(state => state.lhsReducer.selectedApi);
    if(!selected){
        selected = 'option-a';
    }
    var urlIdArray;
    var partnerName = getPartnerName();
    if (partnerName !== "cybs"){
        var cybsProductMapJson = getProductMapJson("cybs");
        var partnerProductMapJson = getProductMapJson(partnerName);
        // cybsMisMatchedProductJson variables and logic will be removed when this Mismatched Product Family Names are changed in SPEC 
        var cybsMisMatchedProductJson = getProductMapJson("api-ref-keymap");
        if (cybsProductMapJson && partnerProductMapJson && Object.entries(cybsProductMapJson).length != 0 && Object.entries(partnerProductMapJson).length != 0) {
            putDataInDevCenterDataStore({type:'UPDATE_CYBS_PRODUCT_MAP_JSON', cybsProductMapJson: cybsProductMapJson});
            putDataInDevCenterDataStore({type:'UPDATE_PARTNER_PRODUCT_MAP_JSON', partnerProductMapJson: partnerProductMapJson});
            if (cybsMisMatchedProductJson && Object.entries(cybsMisMatchedProductJson).length != 0) {
                putDataInDevCenterDataStore({type:'UPDATE_CYBS_MIS_MATCHED_PRODUCT_JSON', cybsMisMatchedProductJson: cybsMisMatchedProductJson});
            }
        }
    }

    var deprecatedProductsList = getProductMapJson("deperecated-product-list");
    if (deprecatedProductsList && Object.entries(deprecatedProductsList).length != 0) {
        putDataInDevCenterDataStore({type:'UPDATE_DEPRECATED_PRODUCTS_LIST', deprecatedProductsList: deprecatedProductsList}); 
    }

    const handleNavClick = ({ id }) => {
        navigationHelper(lhsContents, id);
    };

    const handleStateChange = stateChangeObj => {
        return stateChangeObj.nextState;
    };

    const customData = require('../../dist/json/lhs/'+getLHSBasedOnHostName());
    if(!processed) {
        lhsContents = getLHSJsonData(componentList, customData,lhsContents, false);
        processed = true;
    }
    

      window.addEventListener('scroll', function (event) {
        if($("#nav-bar") && window.pageYOffset > 86 ){
            $("#nav-bar").css("top","0px");
            $("#nav-bar").css("height", "100%");
            // $(".nav-item").addClass( "border_color_theme_tertiary");
        }
        else if($("#nav-bar")){
            $("#nav-bar").css("top",(86-window.pageYOffset)+"px");
            $("#nav-bar").css("height", "100%");
            // $(".nav-item").addClass( "border_color_theme_tertiary");
        }
    }, true);


    //Deep Linking Code
    var homeSectionLinkFlag = useSelector(state => state.lhsReducer.homeSectionLinkFlag);
    setTimeout(function(){
        $(".nav-item").attr("tabindex","0");
    })

    if(homeSectionLinkFlag == true || window.location.hash ){
        var hashValue = encodeURI(window.location.hash);
        var decodedHashValue = decodeURI(hashValue)
        urlIdArray = decodedHashValue.replace('#','').split('_'); //Splitting Deep Linked Hash to determine API
        var selectedId;

        //Get target 3rd level API from Produt/Sub Product Family
        if(!urlIdArray[2]){
            if(!urlIdArray[1]){
                selectedId = getDefaultApiFromParentClass(lhsContents,urlIdArray);
            }
            else{
                selectedId = getDefaultApiFromSubProductFamily(lhsContents,urlIdArray);
            }
        }
        else{
            selectedId = validateThirdLevelApiName(lhsContents,urlIdArray);
        }
        if(urlIdArray[0]!== selected && selectedId !== selected && !getPrerequisitesFlag()){       //Check to avoid deep linking in case of Simple LHS Navigation
            setTimeout(function(){
                renderCounter++;
                if(renderCounter === 1 || homeSectionLinkFlag){                                   //Check to avoid multiple calls to Deep Link function
                    initiateDeepLink(lhsContents,selectedId);
                    if(homeSectionLinkFlag){
                        putDataInDevCenterDataStore({type: 'UPDATE_HOME_SECTION_LINK_FLAG', homeSectionLinkFlag: false});
                        clearResponseFields();
                    }
                    putDataInDevCenterDataStore({type: 'UPDATE_DEEPLINK_FLAG', deepLinkFlag: true});
                    putDataInDevCenterDataStore({type: 'UPDATE_SELECTED_API', selectedApi: selectedId})
                    $('a[state^="selected"]').removeAttr('state');
                    $('a[href^='+selectedId+']').attr('state','selected');
                    showDivBasedOnId('nav-bar')
                }
            }, 10);
        }
        putDataInDevCenterDataStore({type: 'UPDATE_PREREQUISITES_FLAG', prerequisitesFlag: false});
    }
    else{                                             //Go to homepage in case of no hash in URL
        setTimeout(function(){
            $(".nav-item").addClass("color_theme_tertiary");
            showDivBasedOnId('nav-bar');
            showDivBasedOnId('static-home-section');
        })
    }
    return (
        <div className="navigation-bar" style={{'height': "100vh"}}>
                <VDSUINavigation
                    items={lhsContents}
                    handleNavClick={handleNavClick}
                    onStateChange={handleStateChange}
                    activeItem={selected}
                    urlIdArray={urlIdArray}
                />
        </div>
    );
    
};


CustomSliderExample.displayName = 'CustomSliderExample';
export default CustomSliderExample;
export {navigationHelper};
